import { render, staticRenderFns } from "./remessa-boletos.vue?vue&type=template&id=45759b9a"
import script from "./remessa-boletos.vue?vue&type=script&lang=js"
export * from "./remessa-boletos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports